import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  createOrganAction,
  getOrganAction,
  getTypeSurgeryAction,
  updateOrganAction,
  updateTypeSurgeryAction,
} from "../../Actions/SurgeryAction/SurgeryAction";
import { MdOutlineSaveAlt } from "react-icons/md";

const OrganModal = ({ closeModal, en_name, ku_name, id, typeSurgeryId }) => {
  const [inputValue, setInputValue] = useState({
    typeSurgeryId: typeSurgeryId || "",
    en_name: en_name || "",
    ku_name: ku_name || "",
  });
  const createOrgan = useSelector((state) => state.createOrgan);
  const { error } = createOrgan;
  useEffect(() => {
    dispatch(getTypeSurgeryAction());
  }, []);
  const surgeryList = [];
  const getTypeSurgery = useSelector((state) => state.getTypeSurgery);
  const { typeSurgeries, loading } = getTypeSurgery;

  typeSurgeries?.map((surgery) => {
    surgeryList.push({
      label: surgery.name,
      value: surgery.id,
    });
  });

  const dispatch = useDispatch();
  const handleInputChange = (event) => {
    const { value, name } = event.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (id) {
      dispatch(
        updateOrganAction(id, inputValue.en_name, inputValue.ku_name,inputValue.typeSurgeryId)
      );
      closeModal();
    } else {
      dispatch(
        createOrganAction(
          inputValue.typeSurgeryId,
          inputValue.en_name,
          inputValue.ku_name
        )
      );
      dispatch(getOrganAction(""));
      dispatch(getOrganAction(""));
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal ">
        <div className="modal-container mt-4">
          <div className="modal-header ">
            <h3 className="cursor-pointer" onClick={closeModal}>
              X
            </h3>
          </div>

          <form action="" onSubmit={handleSubmit}>
            <div className="w-full mt-2">
              <Select
                options={surgeryList}
                onChange={(selectOpt) => {
                  setInputValue({
                    ...inputValue,
                    typeSurgeryId: selectOpt.value,
                  });
                }}
                value={surgeryList.find(
                  (surgery) => surgery.value === inputValue.typeSurgeryId
                )}
              />

              <p className="text-red-500 ">{error && error.type_surgery_id}</p>
            </div>
            <div className="flex gap-2 w-full my-3">
              <div className="flex flex-col w-full">
                <div>
                  <label htmlFor="name">Organ Level *</label>
                </div>
                <input
                  type="text"
                  name="en_name"
                  placeholder="Organ Level"
                  className="input w-full p-1"
                  onChange={handleInputChange}
                  value={inputValue.en_name}
                />

                <p className="text-red-500 ">{error && error.en_name}</p>
              </div>
              <div className="flex flex-col w-full">
                <div>
                  <label htmlFor="name">TYP *</label>
                </div>
                <input
                  type="text"
                  name="ku_name"
                  placeholder="TYP"
                  className="input w-full p-1"
                  onChange={handleInputChange}
                  value={inputValue.ku_name}
                />

                <p className="text-red-500 ">{error && error.ku_name}</p>
              </div>
            </div>

            <button className="btn-primary mt-2 flex items-center gap-2">
              Save <MdOutlineSaveAlt />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OrganModal;
